import * as d3 from "d3";
import { useEffect, useRef } from "react";
import { useAppSelector } from "../slices";
import * as Cases from '../slices/casesSlice';

const DrawTrackerPercent = (element: any, size: number, progress: number) => {
	const PI = 3.14159265359;

	d3.select(element).select("svg").remove();

	const svg = d3
		.select(element)
		.append("svg")
		.attr("preserveAspectRatio", "xMidYMid meet")
		.attr("height", size)
		.attr("width", size)
		.attr("viewBox", `0 0 ${size} ${size}`)
		.append("g")
		.attr("transform", `translate(${size / 2}, ${size / 2})`);

	size -= 4;
	svg.append("circle")
		.attr("r", 0)
		.attr("stroke", "#513764")
		.attr("fill", "#ffffff")
		.attr("stroke-width", 4)
		.transition().duration(750)
		.attr("r", (size / 2));

	svg.append("clipPath")
		.attr("id", "percent-clip")
		.append("circle")
		.attr("r", 0)
		.transition().duration(750)
		.attr("r", (size / 2));

	const percent = svg.append("text")
		.attr("font-family", "OpenSans-Bold")
		.attr("font-size", Math.ceil(0.35 * size) + "px")
		.attr("fill", '#F4941E')
		.attr("text-anchor", "middle")
		.attr("dominant-baseline", "middle")
		.attr("dx", "5")
		.text(0)
		.attr("clip-path", "url(#percent-clip)")

	percent
		.transition().duration(750)
		.tween("text", () => {
			let i = d3.interpolate(0, progress);
			return function (t: number) {
				const p = i(t);
				this.textContent = (p * 100).toFixed() + '%';
			}
		})

	svg.append("path")
		.attr("d", () => {
			const path = d3.path();
			path.arc(0, 0, (size / 2.75), -(PI), 0);
			return path.toString();
		})
		.attr("id", "labelPath1")
		.attr("stroke", "none")
		.attr("fill", "none")

	svg.append("text")
		.attr("font-family", "OpenSans-Bold")
		.attr("fill", "#513764")
		.attr("font-size", Math.ceil(0.13 * size) + "px")
		.attr("alignment-baseline", "central")
		.attr("clip-path", "url(#percent-clip)")
		.append("textPath")
		.style("text-anchor", "middle")
		.attr("startOffset", "50%")
		.attr("xlink:href", "#labelPath1")
		.text("Overall")

	svg.append("path")
		.attr("d", () => {
			const path = d3.path();
			path.arc(0, 0, (size / 2.25), -(PI), 0, true);
			return path.toString();
		})
		.attr("id", "labelPath2")
		.attr("stroke", "none")
		.attr("fill", "none")

	svg.append("text")
		.attr("font-family", "OpenSans-Bold")
		.attr("fill", "#513764")
		.attr("font-size", Math.ceil(0.13 * size) + "px")
		.attr("alignment-baseline", "central")
		.attr("clip-path", "url(#percent-clip)")
		.append("textPath")
		.style("text-anchor", "middle")
		.attr("startOffset", "50%")
		.attr("xlink:href", "#labelPath2")
		.text("Case Progress")
}

const TrackerPercent = (props: { data: Cases.caseState | null, size: number }) => {
	const cases = useAppSelector(state => state.cases);
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			let size = props.size;
			if ((ref.current as HTMLDivElement).clientWidth < props.size) {
				size = (ref.current as HTMLDivElement).clientWidth;
			}
			if (props.data && props.data.details) {
				DrawTrackerPercent(ref.current, size, (cases.case.details ? cases.case.details.progress : 0));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref]);

	return (
		<div className="DonutChart" style={{ display: 'flex', justifyContent: 'center' }} ref={ref} />
	);

}

export default TrackerPercent;